import { backgroundDefault } from './helper';

export default {
  name: 'mbst-bottom-toolbar__item',
  aliasName: 'Column Bottom Toolbar',
  properties: {
    backendname: 'column-bottom-toolbar'
  },
  css: {
    ios: [
      {
        selector: '.mbst-bottom-toolbar__item',
        rules: [
          { directive: 'width', value: '50%' },
          { directive: 'border-width', value: '0' },
          ...backgroundDefault
        ]
      }
    ],
      android: [
      {
        selector: '.mbst-bottom-toolbar__item',
        rules: [
          { directive: 'width', value: '50%' },
          { directive: 'border-width', value: '0' },
          ...backgroundDefault
        ]
      }
    ]
  },
  components: []
}
